import Page, { PageTab } from "../../shared/components/Page";
import { declareAiTabDestination } from "../ai-omnibar/ai-tab-destinations";
import PatientUtilizationListTab from "./PatientUtilizationListTab";
import UtilizationDashboardTab from "./UtilizationDashboardTab";

// The tab saying it is somewhere to go. The page opens on its dashboard, so the patients tab is
// only reachable by name if it says so itself.
declareAiTabDestination({
  id: "authorizationUtilizationPatients.open",
  title: "Open the Authorization Utilization patients tab",
  stateName: "app.authorization_utilization.patients",
  opens: "page:authorizationUtilizationPatients",
  description:
    "Opens Patients > Authorization Utilization > Patients: utilization per patient, rather than the dashboard's totals.",
  location: "the tab bar of Authorization Utilization",
  permissionKey: "view_authorization_utilization",
  examples: ["authorization utilization by patient"],
});

const tabs: PageTab[] = [
  {
    header: "Dashboard",
    route: "app.authorization_utilization.dashboard",
    component: <UtilizationDashboardTab />,
  },
  {
    header: "Patients",
    route: "app.authorization_utilization.patients",
    component: <PatientUtilizationListTab />,
  },
];

export default function AuthorizationUtilizationRoute() {
  return <Page.Tabbed tabs={tabs} />;
}
